import axios from "axios";
// import { getSession } from 'next-auth/react';

class FetchData {
    constructor(base_url = process.env.REACT_APP_API_URL) {
        this.base_url = base_url;
        this.headers = {};
    }

    async initHeaders(locale = '', token) {
        this.headers = {};
    
        if (token) {
            this.headers.Authorization = `Bearer ${token}`;
        }
    
        if (locale) {
            this.headers['accept-language'] = locale;
        }
    }
    

    async get(url, hasHeader) {
        const actionUrl = this.base_url + url;
        try {
            const config = hasHeader ? { headers: this.headers } : {};
            const response = await axios.get(actionUrl, config);
            return response.data;
        } catch (error) {
            throw new Error(`Get data failed: ${error.message}`);
        }
    }

    async action(url, data, hasHeader) {
        const actionUrl = this.base_url + url;
    
        try {
            const config = hasHeader ? { headers: this.headers } : {};
            const response = await axios.post(actionUrl, data, config);
            return response.data;
        } catch (error) {
            if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            } else {
                throw new Error('Action failed: Unexpected error occurred');
            }
        }
    }
    
}

export default FetchData;
